import React from 'react';
import { useParams } from 'react-router-dom';
import DealsSection from './DealsSection';

function CategoryPage({ user, accessToken, onAddToCart, onRequireLogin, onAuthError, productTypes }) {
  const { typeId } = useParams();

  return (
    <main className="flex flex-1 justify-center py-5 sm:py-8 lg:py-10">
      <div className="layout-content-container flex flex-col max-w-7xl flex-1 px-4 sm:px-10 lg:px-20 w-full">
        <DealsSection
          user={user}
          accessToken={accessToken}
          selectedType={Number(typeId)}
          productTypes={productTypes}
          onAddToCart={onAddToCart}
          onRequireLogin={onRequireLogin}
          onAuthError={onAuthError}
        />
      </div>
    </main>
  );
}

export default CategoryPage;